import { useBottomTabBarHeight } from '@react-navigation/bottom-tabs';

const useBottomMenuHeight = () => {
  try {
    const height = useBottomTabBarHeight();
    return height;
  } catch (e) {
    return 0;
  }
};
export default useBottomMenuHeight;
